import React, { Component } from 'react';
import { LocalizedOutputValue } from '../components/output/OutputValue';
import OutputBox, { OutputBoxContent, Show_IfNOT_Mutagen_Cancerous, Show_If_Mutagen_Cancerous } from '../components/output/OutputBox';
import OutputValue from '../components/output/OutputValue';
import { Horizontal, Vertical } from '../components/container/LayoutRow';
import { dateTimeFormatter } from '../functions/textFormatter';
import { list } from '../cruds/restApi';
import { classNames } from '../functions/classNames';
import ButtonLink from '../components/output/ButtonLink';
import PropTypes from 'prop-types';
import getLabel from '../translations/messages';
import './EvaluationsArchive.css';

const SubstanceOutputText = ({ value, style }) => (
  <span style={style}>{value}</span>
);

class EvaluationsArchive extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { selected: '' };
  }

  componentDidMount = () => {
    this.fetchResults();
  };

  fetchResults = () => {
    list(this.props.entityName, {})
      .then(data => this.setState({
                    data: data,
                    selected: data ? data[0] : '',
                  }));
  };

  selectRow = (id) => {
    const { data } = this.state;

    this.setState({ selected: data.find(d => d.id === id) });
  };

  renderListRow = (id, timestamp, index) => {
    const isSelected = (this.state.selected.id === id);

    return <div className={classNames('ListRow', isSelected ? 'selected' : '')}
                key={id}
                onClick={() => this.selectRow(id)}>
            <div>
              <span>{dateTimeFormatter(timestamp)}</span>
              <span style={{ marginLeft: 15 }}>{'(' + index + ')'}</span>
            </div>
          </div>;
  };

  renderSelected = () => {
    const { selected } = this.state;
    return (
      <Vertical resource={selected}>
      
	  <Show_If_Mutagen_Cancerous>
	  <Horizontal style={{ backgroundColor: 'rgb(248, 252, 253)' }}>	                			
      <OutputBoxContent label="substancesManagement.revelationProcessTemperaturePre" style={{ flex: 2 }}>
      <LocalizedOutputValue name="revelationProcessTemperaturePre" prefix="substancesManagement.revelationProcessTemperatureValuesPre" />
    </OutputBoxContent>
    <OutputBox name="revelationHandlingTimeMinutesPre" label="substancesManagement.revelationHandlingTimeMinutesPre" style={{ flex: 3 }} />    
    <OutputBox name="revelationFrequencyOfUseDaysPre" label="substancesManagement.revelationFrequencyOfUseDaysPre" style={{ flex: 3 }} />
      </Horizontal>
  </Show_If_Mutagen_Cancerous>
      
      
  <Show_IfNOT_Mutagen_Cancerous>   
  <Horizontal style={{ backgroundColor: 'rgb(248, 252, 253)' }}>
  <OutputBoxContent label="substancesManagement.dailyQuantity.displayLabel" style={{ flex: 2 }}>
    <Vertical>
      <Horizontal style={{ alignItems: 'center' }}>
        <SubstanceOutputText value="Max" />
        <OutputValue name="maxDailyQuantity.value" style={{ marginLeft: '10px', marginRight: '5px' }} />
        <OutputValue name="maxDailyQuantity.unit" />
      </Horizontal>
      <Horizontal>
        <SubstanceOutputText value="Min" />
        <OutputValue name="minDailyQuantity.value" style={{ marginLeft: '10px', marginRight: '5px' }} />
        <OutputValue name="minDailyQuantity.unit" />
      </Horizontal>
    </Vertical>
  </OutputBoxContent>
  <OutputBoxContent label="substancesManagement.presentQuantity.displayLabel" style={{ flex: 2 }}>
    <Horizontal style={{ alignItems: 'center' }}>
      <SubstanceOutputText value="Max" />
      <OutputValue name="maxActualQuantity.value" style={{ marginLeft: '10px', marginRight: '5px' }} />
      <OutputValue name="maxActualQuantity.unit" />
    </Horizontal>
  </OutputBoxContent>
  <OutputBoxContent label="substancesManagement.frequency.displayLabel" style={{ flex: 2 }}>
    <LocalizedOutputValue name="contactFrequency" prefix="substancesManagement.contactFrequencyValues" />
  </OutputBoxContent>
  <OutputBoxContent label="substancesManagement.expositionTime.displayLabel" style={{ flex: 2 }}>
    <LocalizedOutputValue name="exposureTime" prefix="substancesManagement.expositionTimeValues" />
  </OutputBoxContent>
</Horizontal>
  </Show_IfNOT_Mutagen_Cancerous>   

        
        
        <Show_If_Mutagen_Cancerous>  
        <Horizontal style={{ backgroundColor: 'rgb(248, 252, 253)' }}>
        <OutputBoxContent label="evaluations.revelationCollectiveProtectionFactor" style={{ flex: 3 }}>
	        <LocalizedOutputValue name="revelationCollectiveProtectionFactor" prefix="evaluations.revelationCollectiveProtectionFactorValues" />	
	    </OutputBoxContent>                   
	    <OutputBoxContent label="evaluations.revelationProcessTemperature" style={{ flex: 3 }}>
	        <LocalizedOutputValue name="revelationProcessTemperature" prefix="evaluations.revelationProcessTemperatureValues" />	
	    </OutputBoxContent>                  
	    <OutputBoxContent label="evaluations.revelationChemicalPhysicalState" style={{ flex: 3 }}>
	        <LocalizedOutputValue name="revelationChemicalPhysicalState" prefix="evaluations.revelationChemicalPhysicalStateValues" />	
	    </OutputBoxContent>                           
        </Horizontal>        
        </Show_If_Mutagen_Cancerous>
        <Show_If_Mutagen_Cancerous>  
        <Horizontal style={{ backgroundColor: 'rgb(248, 252, 253)' }}>  
        <OutputBoxContent label="evaluations.revelationAmountUsed" style={{ flex: 1 }}>
        <LocalizedOutputValue name="revelationAmountUsed" prefix="evaluations.revelationAmountUsedValues" />	
	    </OutputBoxContent>  
	    <OutputBox name="revelationHandlingTimeMinutes" label="evaluations.revelationHandlingTimeMinutes" style={{ flex: 3 }} />    
	    <OutputBox name="revelationFrequencyOfUseDays" label="evaluations.revelationFrequencyOfUseDays" style={{ flex: 3 }} />  
        </Horizontal>          
        </Show_If_Mutagen_Cancerous>
        <Show_If_Mutagen_Cancerous>  
        <Horizontal style={{ backgroundColor: 'rgb(248, 252, 253)' }}> 
        <OutputBox name="bigP" label="evaluations.bigP" style={{ flex: 2 }} />
        <OutputBox name="bigT" label="evaluations.bigT" style={{ flex: 2 }} />
        <OutputBox name="bigS" label="evaluations.bigS" style={{ flex: 2 }} />
        <OutputBox name="bigQ" label="evaluations.bigQ" style={{ flex: 2 }} />          
        </Horizontal>          
        </Show_If_Mutagen_Cancerous>
        <Show_If_Mutagen_Cancerous>  
        <Horizontal style={{ backgroundColor: 'rgb(248, 252, 253)' }}> 
        <OutputBox name="bigE" label="evaluations.bigE" style={{ flex: 3 }} />
        <OutputBox name="bigF" label="evaluations.bigF" style={{ flex: 3 }} />
        <OutputBox name="lcanc"
            label="evaluations.lcanc.name"
            style={{ flex: 3 }}
          />        
        </Horizontal>          
        </Show_If_Mutagen_Cancerous>

        
        
        <Show_IfNOT_Mutagen_Cancerous>   
        <Horizontal style={{ backgroundColor: 'rgb(248, 252, 253)' }}>
          <OutputBoxContent label="evaluations.inhalationDistance" style={{ flex: 1 }}>
            <LocalizedOutputValue name="inhalationDistance" prefix="evaluations.inhalationDistanceValues" />
          </OutputBoxContent>
          <OutputBoxContent label="evaluations.inhalationQuantity" style={{ flex: 1 }}>
            <LocalizedOutputValue name="inhalationQuantity" prefix="evaluations.inhalationQuantityValues" />
          </OutputBoxContent>
          <OutputBoxContent label="evaluations.inhalationProperty" style={{ flex: 2 }}>
            <LocalizedOutputValue name="inhalationProperty" prefix="evaluations.inhalationPropertyValues" />
          </OutputBoxContent>
          <OutputBoxContent label="evaluations.inhalationSystemType" style={{ flex: 2 }}>
            <LocalizedOutputValue name="inhalationSystemType" prefix="evaluations.inhalationSystemTypeValues" />
          </OutputBoxContent>
          <OutputBoxContent label="evaluations.inhalationControlType" style={{ flex: 2 }}>
            <LocalizedOutputValue name="inhalationControlType" prefix="evaluations.inhalationControlTypeValues" />
          </OutputBoxContent>
          <OutputBoxContent label="evaluations.inhalationExposureTime" style={{ flex: 1 }}>
            <LocalizedOutputValue name="inhalationExposureTime" prefix="substancesManagement.expositionTimeValues" />
          </OutputBoxContent>
        </Horizontal>
        </Show_IfNOT_Mutagen_Cancerous>
        <Show_IfNOT_Mutagen_Cancerous>
        <Horizontal style={{ backgroundColor: 'rgb(248, 252, 253)' }}>
          <OutputBox name="smallD" label="evaluations.smallD" style={{ flex: 1 }} />
          <OutputBox name="bigD" label="evaluations.bigD" style={{ flex: 3 }} />
          <OutputBox name="bigU" label="evaluations.u" style={{ flex: 2 }} />
          <OutputBox name="bigC" label="evaluations.c" style={{ flex: 2 }} />
          <OutputBox name="bigI" label="evaluations.i" style={{ flex: 2 }} />
          <OutputBox name="eInal" label="evaluations.einal" style={{ flex: 2 }} />
          <OutputBox name="rInal" label="evaluations.rinal" style={{ flex: 2 }} />
          <OutputBox name="rInalH" label="evaluations.rinalH" style={{ flex: 2 }} />
        </Horizontal>
        </Show_IfNOT_Mutagen_Cancerous>
        <Show_IfNOT_Mutagen_Cancerous>
        <Horizontal style={{ backgroundColor: 'rgb(248, 252, 253)' }}>
          <OutputBoxContent label="evaluations.skinSystemType" style={{ flex: 1 }}>
            <LocalizedOutputValue name="skinSystemType" prefix="evaluations.skinSystemTypeValues" />
          </OutputBoxContent>
          <OutputBoxContent label="evaluations.skinContactLevel" style={{ flex: 1 }}>
            <LocalizedOutputValue name="skinContactLevel" prefix="evaluations.skinContactLevelValues" />
          </OutputBoxContent>
          <OutputBox name="ecute" label="evaluations.ecute" style={{ flex: 2 }} />
          <OutputBox name="rcute" label="evaluations.rcute" style={{ flex: 1 }} />
          <OutputBox name="rcuteH" label="evaluations.rcuteH" style={{ flex: 1 }} />
        </Horizontal>
        </Show_IfNOT_Mutagen_Cancerous>
        <Show_IfNOT_Mutagen_Cancerous>
        <Horizontal style={{ backgroundColor: 'rgb(248, 252, 253)' }}>
        <OutputBox name="scoreP" label="evaluations.scoreP" style={{ flex: 1 }} />
        <OutputBox name="scoreH" label="evaluations.scoreH" style={{ flex: 1 }} />
        <OutputBox name="rcum" label="evaluations.rcum.name" style={{ flex: 1 }} />
        <OutputBox name="rcumH" label="evaluations.rcumH.name" style={{ flex: 1 }} />
        </Horizontal>
        </Show_IfNOT_Mutagen_Cancerous>
        
      </Vertical>
    );
  };

  render() {
    const { data, selected } = this.state;

    return (
      <div className="EvaluationsArchive">
        <div className="header">
          <h2>{[
            getLabel(this.context.locale, 'evaluations.archive'),
            (selected ? selected.departmentName : ''),
            (selected ? selected.activityName : ''),
            (selected ? selected.substanceCode : '')
          ].join(' ')}</h2>
        </div>
        <div className="content">
          <div className="left">
            {data ? data.map((d, i) => this.renderListRow(d.id, d.timestamp, data.length - i)) : ''}
          </div>
          <div className="right">
            {this.state.selected ? this.renderSelected() : ''}
          </div>
        </div>
        <div className="buttons">
          <ButtonLink to={'/substances/management'} label="general.close" />
        </div>
      </div>
    );
  }

}

EvaluationsArchive.contextTypes = {
  locale: PropTypes.string,
};

export default EvaluationsArchive;



// WEBPACK FOOTER //
// ./src/main/pages/EvaluationsArchive.js